import React from 'react';
import styled from 'styled-components';

interface Props {
	field: string;
	value?: string;
	title: string;
	onChange: (field: string, value: string) => void;
	disabled?: boolean;
}

const InputFieldWrapper = styled.div`
	.disabled {
		color: lightgray;
	}
`;

const createInput = (disabled: boolean | undefined, field: string, value: string | undefined, onChange: (field: string, value: string) => void, className?: string) => (
	<input
		className={className}
		type="text"
		defaultValue={value}
		onChange={(e: React.ChangeEvent<HTMLInputElement>) => onChange(field, e.target.value)}
		disabled={disabled}
		/>
);

export const InputField: React.FC<Props> = (props: Props) => {
	const { field, value, title, onChange, disabled } = props;
	const disabledClass = disabled ? 'disabled' : '';
	return (
		<InputFieldWrapper className="inputFieldWrapper">
			<label htmlFor={`sim- + ${field}`}>
				<span className={disabledClass}>{title}</span>
			</label>
			{createInput(disabled, field, value, onChange, disabledClass)}
		</InputFieldWrapper>
	);
};
